import { SVButton } from '@/components/core';
import { MESSAGES } from '@/constants/messages';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import showToast from '@/utils/toast';
import { Stack } from '@mui/material';

type LockTeammateFormProps = {
  teammateFullName: string;
  lockTeammate: UseMutateAsyncFunction<unknown, Error, void, unknown>;
  isLockTeammatePending: boolean;
  onSuccess: () => void;
  onCancel: () => void;
};

export default function LockTeammateForm({
  teammateFullName,
  lockTeammate,
  isLockTeammatePending,
  onSuccess,
  onCancel,
}: LockTeammateFormProps) {
  const handleSubmit = async () => {
    try {
      await lockTeammate();
      showToast({
        type: 'success',
        data: {
          content:
            'Teammate ' + teammateFullName + ' has been successfully locked.',
        },
      });
      onSuccess();
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  };

  return (
    <Stack spacing={2} direction="row" justifyContent="flex-end" mt={4}>
      <SVButton onClick={onCancel} variant="tertiary">
        No, Cancel
      </SVButton>
      <SVButton
        isLoading={isLockTeammatePending}
        variant="error"
        onClick={handleSubmit}>
        Yes, Lock Teammate
      </SVButton>
    </Stack>
  );
}
